export const segmentEventTypes = {
  CITY_OVERVIEW: 'City Overview',
  LOCATION_WATCHING: 'Location Watching',
  LOGIN: 'Login',
  LOGOUT: 'Logout',
  VIDEO_HEARTBEAT: 'Video Heartbeat',
  VIDEO_PLAYBACK_STARTED: 'Video Playback Started',
  VIDEO_PLAYBACK_COMPLETED: 'Video Playback Completed',
  VIDEO_QUARTILE_VOD: 'Video Quartile', // VOD only
  ERROR_LOG: 'ErrorLog',
  VIDEO_ERROR_LOG: 'VideoErrorLog',
  MAP: 'Map',
  MAP_OVERLAY: 'Map Overlay',
  LOCATION_ADDED: 'Location Added',
  LOCATION_SEARCHED: 'Location Searched',
  DEFAULT_LOCATION: 'Default',
  DAILY_FORECAST: 'Daily Forecast',
  HOURLY_FORECAST: 'Hourly Forecast',
  NOW_FORECAST: 'Now Forecast',
  APP_INSTALLED: 'Application Installed',
  LIVE_RAMP_CALL: 'LiveRamp Call',
  LIVE_RAMP_CALL_ERROR: 'LiveRamp Call Error',
} as const;
